import { ImageWrapper } from '@/components/image'

import type { StoryCardStory } from './types'

/** Storyblok occasionally hands back protocol-relative asset URLs. */
const normalizeImageUrl = (url: string): string => (url.startsWith('//') ? `https:${url}` : url)

interface StoryCardArtProps {
  story: StoryCardStory
  origin: string
  sizes: string
  eager?: boolean
  minWidth?: number
  maxWidth?: number
  /** Placeholder wordmark scale — the compact card's tile is much smaller. */
  compact?: boolean
}

/**
 * A story card's artwork, including the branded fallback for stories with no
 * image. Shared so the gradient placeholder can't drift between the pages that
 * render story cards.
 */
export const StoryCardArt = ({
  story,
  origin,
  sizes,
  eager = false,
  minWidth = 112,
  maxWidth = 720,
  compact = false,
}: StoryCardArtProps) => (
  <figure className="bg-navy-10 relative m-0 aspect-16/10 overflow-hidden rounded-2xl">
    {story.imageUrl ? (
      <ImageWrapper
        image={normalizeImageUrl(story.imageUrl)}
        origin={origin}
        loadTime={eager ? 'eager' : 'lazy'}
        imgProps={{
          alt: story.title,
          className: 'h-full w-full object-cover transition-transform duration-500 group-hover/story:scale-[1.025]',
        }}
        sizingProps={{ fixed: false, minWidth, maxWidth, sizes }}
      />
    ) : (
      <div className={`flex h-full items-end bg-[linear-gradient(145deg,#e7edf8,#c8d8f3)] ${compact ? 'p-4' : 'p-5'}`}>
        <span
          className={`text-navy/45 font-semibold tracking-[0.12em] uppercase ${compact ? 'text-[0.6rem]' : 'text-xs'}`}
        >
          HearingTracker
        </span>
      </div>
    )}
  </figure>
)
